import type { ButtonState } from './cost-to-build-client-ui-button.types';

export const BUTTON_INITIAL_STATE: ButtonState = {
    ariaLabel: '',
    clickCount: 0,
    disabled: false,
    id: '',
    label: '',
    loading: false,
    size: 'md',
    type: 'button',
    variant: 'primary',
};

export const areButtonStatesEqual = (left: ButtonState, right: ButtonState) =>
    left.ariaLabel === right.ariaLabel &&
    left.clickCount === right.clickCount &&
    left.disabled === right.disabled &&
    left.id === right.id &&
    left.label === right.label &&
    left.loading === right.loading &&
    left.size === right.size &&
    left.type === right.type &&
    left.variant === right.variant;
